import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const HomeOutline: React.FC<NormalIconProps> = (props) => {
	return (
		<svg onClick={props.onClick} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1 11.2039C1 8.91549 1 7.77128 1.5192 6.82274C2.0384 5.87421 2.98695 5.28551 4.88403 4.10813L6.88403 2.86687C8.88939 1.62229 9.89206 1 11 1C12.1079 1 13.1106 1.62229 15.116 2.86687L17.116 4.10812C19.0131 5.28551 19.9616 5.87421 20.4808 6.82274C21 7.77128 21 8.91549 21 11.2039V12.725C21 16.6258 21 18.5763 19.8284 19.7881C18.6569 21 16.7712 21 13 21H9C5.22876 21 3.34315 21 2.17157 19.7881C1 18.5763 1 16.6258 1 12.725V11.2039Z"
				stroke="white"
				stroke-width="1.5"
			/>
			<path transform="translate(7, 15)" d="M7 1H1" stroke="white" stroke-width="1.5" stroke-linecap="round" />
		</svg>
	);
};
